/**
 * add placeholder styles
 */
export const initBox = ($box: HTMLElement) => {
    $box.classList.add('jso-nature-box');
    $box.style.position = 'relative';

    const $contents = $box.querySelectorAll('[data-content]');
    for(let i=0; i<$contents.length; i++){
        const $content = $contents[i] as HTMLElement;
        $content.style.position = 'relative';
        $content.style.zIndex = '1';
    }
};

/**
 * create canvas dynamically
 */
export const createCanvas = ($box: HTMLElement) => {

    // if canvas element has already been created -> don't create it one more time 
    let $canvas = $box.querySelector('[data-jso-nature-canvas]') as HTMLCanvasElement;
    if($canvas) return $canvas;

    // create canvas element
    $canvas = document.createElement('canvas') as HTMLCanvasElement;
    $canvas.classList.add('jso-nature-canvas');

    $canvas.setAttribute('data-jso-nature-canvas', '');

    const rect = $box.getBoundingClientRect();
    $canvas.width = rect.width; // $box.clientWidth;
    $canvas.height = rect.height; // $box.clientHeight;

    $canvas.style.position = 'absolute';
    $canvas.style.top = '0';
    $canvas.style.left = '0';
    $canvas.style.zIndex = '0';

    // add the canvas to the box
    $box.prepend($canvas);

    return $canvas;
};

/**
 * handle resize
 */
export const handleResize = (
    $box: HTMLElement, 
    $canvas: HTMLCanvasElement, 
    draw: Function, 
    gl: WebGLRenderingContextStrict, 
    uResolution: WebGLUniformLocation) => {

    const supported = 'ResizeObserver' in window;
    
    if(supported){
        const resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                $canvas.width = entry.contentRect.width;
                $canvas.height = entry.contentRect.height;

                // define webgl viewport
                gl.viewport(0, 0, entry.contentRect.width, entry.contentRect.height);

                // update uResolution that is passed to the fragment shader
                gl.uniform2fv(uResolution, new Float32Array([gl.drawingBufferWidth, gl.drawingBufferHeight]));
            }

            draw();
        });

        resizeObserver.observe($box);

        return resizeObserver;
    }

    return null;
};

/**
 * check if document is hidden
 */
export const isDocumentHidden = () => {
    return !!document && document.hidden;
};
